module.exports = __webpack_public_path__ + "static/media/047.349e1d1c.png";